var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,16.1c-0.3,0.2-0.5,0.5-0.8,0.7c-1.9-1.7-3.3-3.3-4.2-4.8S4.3,9.4,4.3,8.3c0-1.7,0.5-3.1,1.6-4.2 c1.1-1.1,2.4-1.6,4-1.6s2.9,0.5,4,1.6c0.2,0.2,0.3,0.4,0.5,0.6c0.9,0.1,1.8,0.4,2.6,0.8c-0.4-1.1-1-2.1-1.8-2.9 c-1.5-1.4-3.2-2.1-5.2-2.1S6.1,1.4,4.6,2.7C3.1,4.1,2.4,6,2.4,8.3c0,1.6,0.6,3.2,1.9,5.1s3.1,3.8,5.6,5.9c1-0.8,1.9-1.7,2.7-2.5 C11.9,16.7,11.2,16.5,10.6,16.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.1,8.4 13.5,10 12,8.5 11.1,9.4 12.6,11 11.1,12.5 12,13.4 13.5,11.9 15.1,13.4 16,12.5 14.5,10.9  16,9.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,8.8c-0.3-0.7-0.7-1.3-1.2-1.7c-0.4-0.4-1-0.8-1.7-1.2c-0.6-0.3-1.3-0.4-2.1-0.4S12,5.6,11.4,5.9 c-0.7,0.3-1.3,0.7-1.7,1.2c-0.4,0.4-0.8,1-1.2,1.7c-0.3,0.6-0.4,1.3-0.4,2.1s0.1,1.5,0.4,2.1c0.3,0.7,0.7,1.3,1.2,1.7 c0.4,0.4,1,0.8,1.7,1.2c0.6,0.3,1.3,0.4,2.1,0.4s1.5-0.1,2.1-0.4c0.7-0.3,1.3-0.7,1.7-1.2c0.4-0.4,0.8-1,1.2-1.7 c0.3-0.6,0.4-1.3,0.4-2.1C19,10.2,18.8,9.4,18.5,8.8z M17.4,11c0,1.1-0.4,2-1.1,2.7c-0.7,0.7-1.7,1.1-2.7,1.1s-2-0.4-2.7-1.1 C10.1,13,9.7,12,9.7,11c0-1.1,0.4-2,1.1-2.7c0.7-0.7,1.7-1.1,2.7-1.1s2,0.4,2.7,1.1C17,9,17.4,9.9,17.4,11z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTrip);
export default __webpack_public_path__ + "static/media/delete-trip.ee9cf40a80d0a175a8e58f0e194cc54d.svg";
export { ForwardRef as ReactComponent };